// extracted by mini-css-extract-plugin
export default {"CustomPackage":"CustomPackage_CustomPackage__2GKfV","customImage":"CustomPackage_customImage__ufRGz"};